<template>
  <div class="animated fadeIn">
   
    <b-row>
      <b-col md="12">
        <b-card no-body>
          <b-row>
            <b-col sm="6" lg="4">
              <b-row class="mt-2 mb-2 mr-2 ml-2">
                <b-col sm="6">
                  
                    <small class="text-muted">dashboard</small><br>
                    <strong class="h4">Créditos e Débitos</strong>
                  
                </b-col>
              </b-row>
              <hr class="ml-2 mt-0">
              
            </b-col>
          
          <b-col sm="6" class="d-flex flex-row flex-nowrap align-items-center justify-content-start ml-2 mr-2 mb-2">
            <!-- Remova o helper CSS inserido antes -->
            <b-row >
              <b-col cols="auto">
                <b-form-input type="date" id="dt1" ref="dt1" placeholder="Informe a data Inicio"
                              v-model="dt1" @keydown.enter="pesquisar()" class="bg-white"></b-form-input>
              </b-col>

              <b-col cols="auto">
                <b-form-input type="date" id="dt2" placeholder="Informe a data Término"
                              v-model="dt2" @keydown.enter="pesquisar()" class="bg-white"></b-form-input>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
          
        </b-card>
        <b-row>
          <b-col sm="9">
            <b-card >
              
              <b-card-title>
                <div class="d-flex justify-content-between align-items-center">
                  <div>Movimentação no Período</div>
                  
                    <b-button v-if="grupoCentroCusto.data && grupoCentroCusto.data.length" class="ml-1"  type="button" variant="none" 
                      @click.stop.prevent="abrirModalLancamentos(null, 'CENTRO_CUSTO_GERAL', 'Centros de Custo')">
                      <span > <i  class="fa fa-ellipsis-v"></i></span>
                    </b-button>
                  
                </div>
              </b-card-title>
              <b-overlay :show="graficoLinhas.isBusy" rounded="sm">  
                <grafico-linhas-lancamentos-caixa 
                    class="chart-wrapper" 
                    style="height:200px;margin-top:40px;" 
                    :height="200"
                    :dt1="dt1"
                    :dt2="dt2"
                    @abrir-modal="abrirModalLancamentosGraficoLinha"
                    @busy="graficoLinhas.isBusy = $event"
                    
                  >
                </grafico-linhas-lancamentos-caixa>
              </b-overlay>
            </b-card>
          </b-col>
          <b-col sm="3">
            <b-card >
              
              <b-card-title>
                <div class="d-flex justify-content-between align-items-center">
                  <div>Valores no Período</div>
                  
                    <b-button v-if="grupoCentroCusto.data && grupoCentroCusto.data.length" class="ml-1"  type="button" variant="none" 
                      @click.stop.prevent="abrirModalLancamentos(null, 'CENTRO_CUSTO_GERAL', 'Centros de Custo')">
                      <span > <i  class="fa fa-ellipsis-v"></i></span>
                    </b-button>
                  
                </div>
              </b-card-title>
              <b-overlay :show="graficoPizza.isBusy" rounded="sm">  
                <grafico-pizza-lancamentos-caixa 
                    class="chart-wrapper" 
                    style="height:200px;margin-top:40px;" 
                    :height="200"
                    :dt1="dt1"
                    :dt2="dt2"
                    @abrir-modal="abrirModalLancamentosGraficoLinha"
                    @busy="graficoPizza.isBusy = $event"
                    
                  >
                </grafico-pizza-lancamentos-caixa>
              </b-overlay>
            </b-card>
          </b-col>
        </b-row>
        
        <div>
          <b-card-group deck>
            <b-card >
              <b-card-title>
                <div class="d-flex justify-content-between align-items-center">
                  <div>Créditos Por Histórico</div>
                  <b-button v-if="grupoHistorico.dataCredito && grupoHistorico.dataCredito.length" class="ml-1"  type="button" variant="none"
                  @click.stop.prevent="abrirModalLancamentos(null, 'HISTORICO_GERAL_CREDITO', 'Créditos por Histórico')">
                    <span > <i  class="fa fa-ellipsis-v"></i></span>
                  </b-button>
                </div>
              </b-card-title>
              <b-row>
                <b-col sm="12">
                  <ul class="horizontal-bars type-2">
                    <li v-for="(item, i) in (grupoHistorico.dataCredito && grupoHistorico.dataCredito.length ? grupoHistorico.dataCredito : [])" :key="item.ID || i"
                    @click.stop="abrirModalLancamentos(item.HISTORICO_ID, 'HISTORICO', 'Historico: ' + item.HISTORICO_ID + ' - ' + item.NOME_HISTORICO + ' - ' + item.TIPO)" style="cursor: pointer;">
                      <span class="title">{{ (item.NOME_HISTORICO || '').length > 30 ? item.NOME_HISTORICO.slice(0, 30) + '...' : item.NOME_HISTORICO }}</span>
                      <span class="value">
                        {{ numberToReal(item.VL_MOV)}}
                        <span class="small" :class="isDark ? 'text-light' : 'text-muted'"> {{ item.PERCENTUAL }}% </span>
                      </span>
                      <div class="bars">
                        <b-progress height="8px" class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="100" :value="item.PERCENTUAL" variant="success"></b-progress>
                      </div>
                    </li>
                  </ul> 
                </b-col>
              </b-row>
            </b-card>

             <b-card >
              <b-card-title>
                <div class="d-flex justify-content-between align-items-center">
                  <div>Débitos Por Histórico</div>
                  <b-button v-if="grupoHistorico.dataDebito && grupoHistorico.dataDebito.length" class="ml-1"  type="button" variant="none" 
                    @click.stop.prevent="abrirModalLancamentos(null, 'HISTORICO_GERAL_DEBITO', 'Débitos por Histórico')">
                    <span > <i  class="fa fa-ellipsis-v"></i></span>
                  </b-button>
                </div>
              </b-card-title>
              <b-row>
                <b-col sm="12">
                  <ul class="horizontal-bars type-2">
                    <li v-for="(item, i) in (grupoHistorico.dataDebito && grupoHistorico.dataDebito.length ? grupoHistorico.dataDebito : [])" :key="item.ID || i"
                    @click.stop="abrirModalLancamentos(item.HISTORICO_ID, 'HISTORICO', 'Historico: ' + item.HISTORICO_ID + ' - ' + item.NOME_HISTORICO + ' - ' + item.TIPO)" style="cursor: pointer;">
                      <span class="title">{{ (item.NOME_HISTORICO || '').length > 30 ? item.NOME_HISTORICO.slice(0, 30) + '...' : item.NOME_HISTORICO }}</span>
                      <span class="value">
                        {{ numberToReal(item.VL_MOV)}}
                        <span class="small" :class="isDark ? 'text-light' : 'text-muted'"> {{ item.PERCENTUAL }}% </span>
                      </span>
                      <div class="bars">
                        <b-progress height="8px" class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="100" :value="item.PERCENTUAL" variant="danger"></b-progress>
                      </div>
                    </li>
                    
                  </ul> 
                </b-col>
              </b-row>
              
            </b-card>


            <b-card class="creditos-card">
              <b-card-title>
                <div class="d-flex justify-content-between align-items-center">
                  <div>Centros de Custo</div>
                  <b-button v-if="grupoCentroCusto.data && grupoCentroCusto.data.length" class="ml-1"  type="button" variant="none" 
                    @click.stop.prevent="abrirModalLancamentos(null, 'CENTRO_CUSTO_GERAL', 'Centros de Custo')">
                    <span > <i  class="fa fa-ellipsis-v"></i></span>
                  </b-button>
                </div>
              </b-card-title>

              <b-overlay :show="grupoCentroCusto.busy" rounded="sm">  
                <b-row>
                  <b-col sm="12">
                    <ul class="horizontal-bars  type-2">
                      <li v-for="(item, i) in (grupoCentroCusto.data && grupoCentroCusto.data.length ? grupoCentroCusto.data : (grupoCentroCusto.data || []))" :key="item.CENTRO_CUSTO_ID || i"
                      @click.stop="abrirModalLancamentos(item.CENTRO_CUSTO_ID, 'CENTRO_CUSTO', 'Centro Custo: ' + item.CENTRO_CUSTO_ID + ' - ' + item.NOME_CENTRO_CUSTO)" style="cursor: pointer;">
                      <span class="title">{{ item.NOME_CENTRO_CUSTO }}</span>

                      <span class="value">
                        {{ numberToReal(item.VL_CREDITO) }}
                        <span class="small" :class="isDark ? 'text-light' : 'text-muted'">{{ item.PERCENTUAL_CREDITO }}%</span>
                      </span>

                      <div class="bars">
                        <b-progress height="8px" class="progress-xs"
                                    :class="isDark ? 'bg-gray-700 text-light' : ''"
                                    :max="100" :value="item.PERCENTUAL_CREDITO"
                                    variant="success"/>
                        <b-progress height="8px" class="progress-xs"
                                    :class="isDark ? 'bg-gray-700 text-light' : ''"
                                    :max="100" :value="item.PERCENTUAL_DEBITO"
                                    variant="danger"/>
                        
                      </div>
                      <!-- valor da 2ª barra abaixo, à direita -->
                      <span  class="value value-below">
                         {{ numberToReal(item.VL_DEBITO) }}
                        <span class="small" :class="isDark ? 'text-light' : 'text-muted'">
                          {{ item.PERCENTUAL_DEBITO  }}%
                        </span>
                      </span>
                      </li>
                    </ul>
                  </b-col>
                </b-row>
              </b-overlay>
            </b-card>

            
          </b-card-group>
        </div>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col md="12"> 
        <div>
          <b-card-group deck>
            <b-card title="12 Meses" >
              <b-overlay :show="grupoUltimoAno.busy" rounded="sm">  
                <b-row>
                  <b-col sm="12">
                    <ul class="horizontal-bars">
                      <li v-for="(item, i) in (grupoUltimoAno.data && grupoUltimoAno.data.length ? grupoUltimoAno.data : (grupoUltimoAno.data || []))" :key="item.MES || i">
                        <div class="title" :class="isDark ? 'text-light' : ''" >
                          {{ item.MES }}
                        </div>
                        <div class="bars" >
                          <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="grupoUltimoAno.maiorCredito" :value="item.CREDITO" variant="success"></b-progress>
                          <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="grupoUltimoAno.maiorDebito" show-value :value="item.DEBITO" variant="danger"></b-progress>
                        </div>
                      </li>
                    </ul>
                  </b-col>
                </b-row>
              </b-overlay>
            </b-card>
             <b-card title="Última Semana" >
              <b-row>
                <b-col>
                   <ul class="horizontal-bars">
                    <li>
                      <div class="title" :class="isDark ? 'text-light' : ''" >
                        Domingo
                      </div>
                      <div class="bars" >
                        <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="grupoSemana.maiorCredito" :value="grupoSemana.domingoCredito" variant="success"></b-progress>
                        <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="grupoSemana.maiorDebito" show-value :value="grupoSemana.domingoDebito" variant="danger"></b-progress>
                      </div>
                    </li>
                    <li>
                      <div class="title" :class="isDark ? 'text-light' : ''">
                        Segunda
                      </div>
                      <div class="bars">
                        <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="grupoSemana.maiorCredito" :value="grupoSemana.segundaCredito" variant="success"></b-progress>
                        <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="grupoSemana.maiorDebito" :value="grupoSemana.segundaDebito" variant="danger"></b-progress>
                      </div>
                    </li>
                    <li>
                      <div class="title" :class="isDark ? 'text-light' : ''">
                        Terça
                      </div>
                      <div class="bars">
                        <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="grupoSemana.maiorCredito" :value="grupoSemana.tercaCredito" variant="success"></b-progress>
                        <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="grupoSemana.maiorDebito" :value="grupoSemana.tercaDebito" variant="danger"></b-progress>
                      </div>
                    </li>
                    <li>
                      <div class="title" :class="isDark ? 'text-light' : ''">
                        Quarta
                      </div>
                      <div class="bars">
                        <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="grupoSemana.maiorCredito" :value="grupoSemana.quartaCredito"  variant="success"></b-progress>
                        <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="grupoSemana.maiorDebito" :value="grupoSemana.quartaDebito" variant="danger"></b-progress>
                      </div>
                    </li>
                    <li>
                      <div class="title" :class="isDark ? 'text-light' : ''">
                        Quinta
                      </div>
                      <div class="bars">
                        <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="grupoSemana.maiorCredito" :value="grupoSemana.quintaCredito"  variant="success"></b-progress>
                        <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="grupoSemana.maiorDebito" :value="grupoSemana.quintaDebito"  variant="danger"></b-progress>
                      </div>
                    </li>
                    <li>
                      <div class="title" :class="isDark ? 'text-light' : ''">
                        Sexta
                      </div>
                      <div class="bars">
                        <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="grupoSemana.maiorCredito" :value="grupoSemana.sextaCredito"  variant="success"></b-progress>
                        <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="grupoSemana.maiorDebito" :value="grupoSemana.sextaDebito"  variant="danger"></b-progress>
                      </div>
                    </li>
                    <li>
                      <div class="title" :class="isDark ? 'text-light' : ''">
                        Sabado
                      </div>
                      <div class="bars">
                        <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="grupoSemana.maiorCredito" :value="grupoSemana.sabadoCredito"  variant="success"></b-progress>
                        <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="grupoSemana.maiorDebito" :value="grupoSemana.sabadoDebito"  variant="danger"></b-progress>
                      </div>
                    </li>
                    <li class="legend">
                      <b-badge pill variant="success"></b-badge> <small>Receitas</small> &nbsp; <b-badge pill variant="danger"></b-badge> <small>Despesas</small>
                    </li>
                  </ul>
                </b-col>
              </b-row>

            </b-card>
            
          </b-card-group>
        </div>
        <b-row>
          <b-col class="mt-3 mb-3">
            <b-btn type="button" variant="primary" @click="$router.go('-1')" ><i class="fa fa-arrow-left"></i> Voltar</b-btn>
          </b-col>

        </b-row>
      </b-col>
    </b-row>
    <!-- só cria o componente quando tiver tudo pronto -->
    <modal-historico-lancamentos
      v-if="modalHistoricos.visible"
      :dt1="modalHistoricos.dt1"
      :dt2="modalHistoricos.dt2"
      :titulo="modalHistoricos.titulo"
      :item-id="modalHistoricos.itemId"
      :tipo-filtro="modalHistoricos.tipoFiltro"
      :inc-gerar="modalHistoricos.incGerar"
    />
  </div>

  
</template>

<script>
import Tools from '@/tools/tools.js'
import { Callout } from '../../components'
import VueButtonSpinner from '../../components/VueButtonSpinner.vue'
import ModalHistoricoLancamentos from './ModalHistoricoLancamentos.vue' 
import GraficoLinhasLancamentosCaixa from './GraficoLinhasLancamentosCaixa.vue'
import GraficoPizzaLancamentosCaixa from './GraficoPizzaLancamentosCaixa.vue'

export default {
  name: 'DespesasPeriodo',
  components: {
    Callout,
    VueButtonSpinner,
    ModalHistoricoLancamentos,
    GraficoLinhasLancamentosCaixa,
    GraficoPizzaLancamentosCaixa
  },
  data: function () {
    return {
      botoes: {
        selecionado: 'detalhado'
      },
      graficoPizza: {
        incremento: 0,
        isBusy: false,
      },
      graficoLinhas: {
        incremento: 0,
        isBusy: false,
      },
      modalHistoricos: { 
        incGerar: 0, //Controla o atualizacao do conteudo do modal
        dt1: this.dt1,
        dt2: this.dt2,
        visible: false, 
        itemId: null,
        tipoFiltro: null,
        titulo: null, 
        tipoMovimento: null 
      },
      grupoCentroCusto: {
        maiorCredito: 0,
        maiorDebito: 0,
        busy: false,
        data: []
      },
      grupoHistorico: {
        historicoCreditoSelecionado: null,
        historicoDebitoSelecionado: null,
        dataCredito: [],
        dataDebito: [],
      },
      grupoSemana: {
        maiorCredito: 0,
        maiorDebito: 0,
        domingoCredito: 0,
        domingoDebito: 0, 
        segundaCredito: 0,
        segundaDebito: 0,
        tercaCredito: 0,
        tercaDebito: 0,
        quartaCredito: 0,
        quartaDebito: 0,
        quintaCredito: 0,
        quintaDebito: 0,
        sextaCredito: 0,
        sextaDebito: 0,
        sabadoCredito: 0,
        sabadoDebito: 0,
      },
      grupoUltimoAno: {
        busy: false,
        data: [],
        maiorCredito: 0,
        maiorDebito: 0,
      },
      
      dt1: new Date().toISOString().substr(0, 10),
      dt2: new Date().toISOString().substr(0, 10),
      isLoading: false,
      status: '',
      submmited: false,

    }
  },
  methods: {
    async pesquisar() {
      await Promise.all([
          this.carregarGrupoHistoricoCredito(),
          this.carregarGrupoHistoricoDebito(),
          this.carregarCentroCusto()
      ])
      this.graficoLinhas.incremento ++
      this.graficoPizza.incremento ++
    },
    async carregarGrupoHistoricoCredito() {
       try {
          const {data} = await this.$http.get('/api/protected/caixa/item/listarCreditosPorPeriodoAgrupadoHistorico', {
            params: {
              dt1: this.dt1,
              dt2: this.dt2
            }
          })

          // Process the response data
          //const arr = Array.isArray(data) ? data : (data && data.data) ? data.data : []
          //const MAX_REGISTROS = 20

          this.grupoHistorico.dataCredito = data
          this.grupoHistorico.dataCreditoReduzido = data
          //this.grupoHistorico.dataCreditoReduzido = arr.slice(0, MAX_REGISTROS)

          
        } catch (error) {
          Tools.exibirMensagem(this.$store, 'Não foi possível buscar os dados', 'danger', error)
        }
    },
    async carregarGrupoHistoricoDebito() {
       try {
          const {data} = await this.$http.get('/api/protected/caixa/item/listarDebitosPorPeriodoAgrupadoHistorico', {
            params: {
              dt1: this.dt1,
              dt2: this.dt2
            }
          })

          // Process the response data
          //const arr = Array.isArray(data) ? data : (data && data.data) ? data.data : []
          //const MAX_REGISTROS = 20

          this.grupoHistorico.dataDebito = data
          //this.grupoHistorico.dataDebitoReduzido = arr.slice(0, MAX_REGISTROS)

          
        } catch (error) {
          Tools.exibirMensagem(this.$store, 'Não foi possível buscar os dados', 'danger', error)
        }
    },
    async carregarCentroCusto() {
       try {
          const {data} = await this.$http.get('/api/protected/caixa/item/listarPeriodoAgrupoPorCentroCusto', {
            params: {
              dt1: this.dt1,
              dt2: this.dt2
            }
          })

          this.grupoCentroCusto.maiorCredito = 0
          this.grupoCentroCusto.maiorDebito = 0
          data.forEach(item => {
            if (item.VL_CREDITO > this.grupoCentroCusto.maiorCredito) {
              this.grupoCentroCusto.maiorCredito = item.VL_CREDITO
            }
            if (item.VL_DEBITO > this.grupoCentroCusto.maiorDebito) {
              this.grupoCentroCusto.maiorDebito = item.VL_DEBITO
            }
          })

          // Process the response data
          //const arr = Array.isArray(data) ? data : (data && data.data) ? data.data : []
          //const MAX_REGISTROS = 20

          this.grupoCentroCusto.data = data

          
        } catch (error) {
          Tools.exibirMensagem(this.$store, 'Não foi possível buscar os dados', 'danger', error)
        }
    },
    
    async carregarSemana () {
      const {data} = await this.$http.get('/api/protected/caixa/item/listarCreditosDebitosUltimaSemana')
      this.grupoSemana.data = data
      let maiorCredito = 0
      let maiorDebito = 0

      this.grupoSemana.data.forEach(item => {
        if (item.CREDITO > maiorCredito) {
          maiorCredito = item.CREDITO
        }
        if (item.DEBITO > maiorDebito) {
          maiorDebito = item.DEBITO
        }
        this.grupoSemana.domingoCredito = item.dataA[0].DIA === 'SEQ' ? item.dataA[0].CREDITO : 0
        this.grupoSemana.domingoDebito = item.dataB[0].DIA === 'SEQ' ? item.dataB[0].DEBITO : 0
        this.grupoSemana.segundaCredito = item.dataA[1].DIA === 'TER' ? item.dataA[1].CREDITO : 0
        this.grupoSemana.segundaDebito = item.dataB[1].DIA === 'TER' ? item.dataB[1].DEBITO : 0
        this.grupoSemana.tercaCredito = item.dataA[2].DIA === 'QUA' ? item.dataA[2].CREDITO : 0
        this.grupoSemana.tercaDebito = item.dataB[2].DIA === 'QUA' ? item.dataB[2].DEBITO : 0
        this.grupoSemana.quartaCredito = item.dataA[3].DIA === 'QUI' ? item.dataA[3].CREDITO : 0
        this.grupoSemana.quartaDebito = item.dataB[3].DIA === 'QUI' ? item.dataB[3].DEBITO : 0
        this.grupoSemana.quintaCredito = item.dataA[4].DIA === 'SEX' ? item.dataA[4].CREDITO : 0
        this.grupoSemana.quintaDebito = item.dataB[4].DIA === 'SEX' ? item.dataB[4].DEBITO : 0
        this.grupoSemana.sextaCredito = item.dataA[5].DIA === 'SAB' ? item.dataA[5].CREDITO : 0
        this.grupoSemana.sextaDebito = item.dataB[5].DIA === 'SAB' ? item.dataB[5].DEBITO : 0
        this.grupoSemana.sabadoCredito = item.dataA[6].DIA === 'DOM' ? item.dataA[6].CREDITO : 0
        this.grupoSemana.sabadoDebito = item.dataB[6].DIA === 'DOM' ? item.dataB[6].DEBITO : 0
      })
      this.grupoSemana.maiorCredito = maiorCredito
      this.grupoSemana.maiorDebito = maiorDebito

    },
    async carregarUltimoAno () {
      try {
        this.grupoUltimoAno.busy = true
        const {data} = await this.$http.get('/api/protected/caixa/item/listarCreditosDebitosUltimosMeses')
        this.grupoUltimoAno.data = data
        let maiorCredito = 0
        let maiorDebito = 0

        this.grupoUltimoAno.data.forEach(item => {
          if (item.CREDITO > maiorCredito) {
            maiorCredito = item.CREDITO
          }
          if (item.DEBITO > maiorDebito) {
            maiorDebito = item.DEBITO
          }
        
        })
        this.grupoUltimoAno.maiorCredito = maiorCredito
        this.grupoUltimoAno.maiorDebito = maiorDebito
      } finally {
        this.grupoUltimoAno.busy = false
      }

    },
    abrirModalLancamentos (itemId, tipoFiltro, titulo) {
      // defina as props ANTES de montar
      this.modalHistoricos.dt1 = this.dt1
      this.modalHistoricos.dt2 = this.dt2
      this.modalHistoricos.itemId = itemId
      this.modalHistoricos.tipoFiltro = tipoFiltro
      this.modalHistoricos.titulo = titulo
      this.modalHistoricos.visible = true
      this.modalHistoricos.incGerar++ 

      this.$nextTick(() => {
        this.$bvModal.show('modal-historico-lancamentos')
      })
    },
    abrirModalLancamentosGraficoLinha (dados) {
      console.log(dados)
      // defina as props ANTES de montar
      this.modalHistoricos.dt1 = dados.dia
      this.modalHistoricos.dt2 = dados.dia
      this.modalHistoricos.itemId = null
      this.modalHistoricos.tipoFiltro = dados.tipo === 'CREDITO' ? 'HISTORICO_GERAL_CREDITO' : 'HISTORICO_GERAL_DEBITO'
      this.modalHistoricos.titulo = `LANÇAMENTOS GERAIS - ${dados.tipo}` 
      this.modalHistoricos.visible = true
      this.modalHistoricos.incGerar++

      this.$nextTick(() => {
        this.$bvModal.show('modal-historico-lancamentos')
      })
    },
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    variantLinha (value) {
      return value === 0 ? 'secondary' : value === 1 ? 'info' : value === 2 ? 'info' : value === 3 ? 'secondary' : value === 4 ? 'danger' : value === 5 ? 'danger' : value === 6 ? 'secondary' : value === 7 ? 'warning' : ''
    },
    flag (value) {
      return 'flag-icon flag-icon-' + value
    },
    numberToReal (numero) {
      if (!numero) return 'R$ 0,00'
      
      let n = numero.toFixed(2).split('.')
      n[0] = 'R$ ' + n[0].split(/(?=(?:...)*$)/).join('.')
      return n.join(',')
    },
    
    
    post () {
      this.isLoading = true
      this.submmited = true
      // let uri = `/api/protected/relatorios/relcompragadoresumidoforcomp?fornecedorId=${this.registro.CLIENTE_ID}&funcionarioId=${this.registro.FUNCIONARIO_ID}&dt1=${this.registro.DT1}&dt2=${this.registro.DT2}&lbFornecedor=${this.parametros.nomecliente}&lbFuncionario=${this.parametros.nomefuncionario}`
      let uri = '/api/protected/relatorios/fluxocaixa/fluxo10dias?&lbempresa=' + window.localStorage.getItem('nomeempresa') +
        '&lbusuario=' + window.localStorage.getItem('nomeusuario')
      this.$http.get(uri, {responseType: 'arraybuffer'})
        .then(response => {
          this.isLoading = false
          this.submmited = false
          this.$toast.success({
            title: 'Sucesso',
            message: 'Relatório Gerado com Sucesso ',
            progressBar: false,
            timeOut: 300,
            showMethod: 'shake',
            position: 'top full width'
          })
          const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'fluxodecaixa10dias.pdf')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .catch(erro => {
          this.$toast.error({
            title: 'Erro',
            message: 'Ocorreram erros ao gerar o Relatorio ',
            progressBar: false,
            showMethod: 'shake',
            position: 'top full width'
          })
          this.isLoading = false
        })
    }
  },
  computed: {
    isDark() {return this.$store.getters['tema/IS_DARK']  },
  },
  watch: {
    async dt1() {
      await this.pesquisar()
    },
    async dt2() {
      await this.pesquisar()
    }
  },
  async created () {
    
    await this.carregarUltimoAno()
    await this.carregarSemana()
    //this.graficoLinhas.incremento ++
  }
}
</script>
<style scoped>
/* só neste card */
.creditos-card .horizontal-bars.type-2 li{
  height: auto;          /* cresce para caber 2 barras */
  line-height: 22px;     /* ↓ baixa o texto */
  padding-top: 0;
  padding-bottom: 8px;
}

/* o type-2 global coloca -9px; zeramos e igualamos a 22px */
.creditos-card .horizontal-bars.type-2 li .title{
  margin-top: 0 !important;
  line-height: 22px;
}

/* alinhar também o valor da direita e o ícone */
.creditos-card .horizontal-bars.type-2 li .value,
.creditos-card .horizontal-bars.type-2 li i{
  line-height: 22px;
}

/* barras no fluxo normal e quase coladas no texto */
.creditos-card .horizontal-bars.type-2 li .bars{
  position: static !important;   /* em vez de absolute */
  margin-top: 2px;               /* encosta nas labels */
  padding: 0;
}

/* distância entre as duas barras */
.creditos-card .horizontal-bars.type-2 li .bars .progress + .progress{
  margin-top: 3px;               /* 2–4px conforme gosto */
}


</style>



// WEBPACK FOOTER //
// src/views/dashboard/DespesasPeriodo.vue